export const ar = {
    // General
    loading: 'جاري التحميل...',
    save: 'حفظ',
    saveSuccess: 'تم الحفظ بنجاح',
    error: 'حدث خطأ',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    search: 'بحث...',
    date: 'التاريخ',
    description: 'الوصف',
    amount: 'المبلغ',
    ai_step_designing: 'جاري تخيل المشهد...',
    ai_step_rendering: 'جاري الرسم والتلوين (Rendering)...',
    ai_step_finalizing: 'جاري المعالجة النهائية...',
    aiGenerationFailed: 'تعذر توليد الصورة. تأكد من اتصال الإنترنت وحاول مرة أخرى.',

    // Dashboard Analytics
    salesOverview: 'نظرة عامة على المبيعات (آخر 7 أيام)',
    dailyRevenue: 'الإيرادات اليومية',
    sales: 'المبيعات',
    revenue: 'الإيرادات',
    totalOrders: 'إجمالي الطلبات',
    avgOrderPrice: 'متوسط قيمة الطلب',
    itemsSold: 'منتجات مباعة',
    activeProducts: 'منتجات نشطة',
    recentOrders: 'أحدث الطلبات',
    viewAll: 'عرض الكل',
    noData: 'لا توجد بيانات متاحة',
    today: 'اليوم',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',
    thisYear: 'هذه السنة',

    // Menu / Sidebar
    accounting: 'الإدارة المالية والمحاسبة',
    overview: 'نظرة عامة',
    chartOfAccounts: 'شجرة الحسابات',
    journalEntries: 'قيود اليومية',
    costCenters: 'مراكز التكلفة (Cost Centers)',
    reports: 'التقارير المالية',
    settings: 'الإعدادات',
    sidebar_openingBalanceEntry: 'القيد الافتتاحي',
    openingBalanceEntry: 'القيد الافتتاحي للأرصدة',
    vouchers: 'السندات المحاسبية',
    cheques: 'الشيكات',
    reconciliation: 'المطابقة البنكية',
    accountingSettings: 'إعدادات النظام المحاسبي',
    settingsSubtitle: 'تحكم في هوية مطعمك وإعدادات النظام.',
    payrollAndHR: 'الرواتب والموارد البشرية',
    payrollSubtitle: 'إدارة مسيرات الرواتب، الحضور، والمستندات',
    attendanceLastUpdate: 'آخر تحديث للحضور',
    noPayrolls: 'لا توجد مسيرات رواتب مصدرة',
    attendanceRecord: 'سجل الحضور',
    newPayroll: 'مسير جديد',
    totalPaid: 'إجمالي المدفوع',
    zatcaIntegration: 'مركز هيئة الزكاة والضريبة (ZATCA)',
    paymentManagement: 'إدارة التسويات والمدفوعات',
    subscription: 'الباقة والاشتراك',
    dashboard: 'لوحة التحكم',
    pos: 'نقاط البيع (POS)',
    orders: 'إدارة الطلبات',
    kds: 'شاشة المطبخ (KDS)',
    support: 'الدعم والمساعدة',
    auth_alreadyHaveAccount: 'لديك حساب بالفعل؟',
    auth_loginNow: 'سجل دخولك الآن',
    auth_agreeTerms: 'بإنشاء الحساب، فأنت توافق على شروط الخدمة وسياسة الخصوصية الخاصة بـ DFOOD.',

    // Accounting Page
    accountingSystem: 'نظام الإدارة المالية',
    accountingSubtitle: 'إدارة شجرة الحسابات، قيود اليومية، والإعدادات المالية المتقدمة.',
    accountingGuide: 'دليل الحسابات الموحد',
    quickActions: 'إجراءات سريعة',
    newVoucherShort: 'إنشاء سند',
    journalEntryShort: 'تسجيل قيد يومية',
    chartOfAccountsShort: 'دليل الحسابات',
    financialReportsShort: 'التقارير المالية',
    financialSnapshot: 'الملخص المالي',
    currentMonthPerformance: 'أداء الشهر الحالي',
    operationalStatus: 'حالة العمليات',
    printCoaPdf: 'طباعة شجرة الحسابات (PDF)',
    arabicName: 'الاسم العربي',
    englishName: 'الاسم الإنجليزي',
    accountTree: 'شجرة الحسابات',

    // Overview Tab
    totalRevenue: 'إجمالي الإيرادات',
    totalExpenses: 'إجمالي المصروفات',
    netProfit: 'صافي الربح',
    assets: 'الأصول (Assets)',
    liabilities: 'الخصوم (Liabilities)',
    equity: 'حقوق الملكية (Equity)',
    recentTransactions: 'أحدث العمليات المسجلة',

    // Accounts Tab
    addAccount: 'إضافة حساب',
    accountName: 'اسم الحساب',
    accountCode: 'رقم الحساب',
    accountType: 'نوع الحساب',
    parentAccount: 'الحساب الرئيسي',

    // Journal Entries Tab
    addEntry: 'إضافة قيد جديد',
    totalEntries: 'إجمالي القيود',
    totalDebit: 'إجمالي المدين',
    totalCredit: 'إجمالي الدائن',
    entryNumber: 'رقم القيد',
    debit: 'مدين',
    credit: 'دائن',
    balance: 'الرصيد',
    difference: 'الفرق',
    saveEntry: 'حفظ القيد',
    entryCreatedSuccess: 'تم إنشاء القيد بنجاح',
    unbalancedEntry: 'القيد غير متوازن',
    descriptionRequired: 'الوصف مطلوب',
    moreFilters: 'مزيد من التصفية',
    hideFilters: 'إخفاء التصفية',
    chooseDate: 'يرجى اختيار التاريخ',
    reversalDate: 'تاريخ عكس القيد',
    confirmReversal: 'تأكيد عكس القيد',
    reversalReasonPlaceholder: 'سبب عكس المسيرة (اختياري)...',
    notes: 'ملاحظات',
    items: 'البنود',
    addRow: 'إضافة سطر',

    // Vouchers Tab
    totalVouchers: 'إجمالي السندات',
    receiptTotal: 'إجمالي المقبوضات',
    paymentTotal: 'إجمالي المدفوعات',
    chooseAccount: 'اختر الحساب',
    itemDescription: 'وصف السطر',
    viewDetails: 'عرض التفاصيل',
    reverseEntry: 'عكس القيد',

    // Cheques Tab
    totalCheques: 'إجمالي الشيكات',
    pendingAmount: 'المبالغ المعلقة',
    clearedAmount: 'المبالغ المحصلة',
    bouncedAmount: 'المبالغ المرتجعة',
    inCount: 'عدد الوارد',
    outCount: 'عدد الصادر',

    // Reconciliation Tab
    openSessions: 'جلسات مفتوحة',
    closedSessions: 'جلسات مغلقة',

    // Cost Centers Tab
    addCostCenter: 'إضافة مركز تكلفة',
    centerName: 'اسم المركز',
    centerCode: 'كود المركز',

    // Reports Tab
    taxReport: 'الإقرار الضريبي',
    trialBalance: 'ميزان المراجعة',
    pnl: 'قائمة الدخل',
    balanceSheet: 'الميزانية العمومية',
    cashFlow: 'التدفقات النقدية',
    agingReport: 'أعمار الديون',
    customerStatement: 'كشف حساب عميل',
    supplierStatement: 'كشف حساب مورد',
    exportExcel: 'تصدير Excel',
    printPdf: 'طباعة / PDF',
    fromDate: 'من',
    toDate: 'إلى',
    chooseCustomer: 'اختر العميل...',
    chooseSupplier: 'اختر المورد...',
    chooseCostCenter: 'اختيار مركز التكلفة',
    allCostCenters: 'جميع مراكز التكلفة',
    reportPeriod: 'فترة التقرير',
    customPeriod: 'فترة مخصصة',
    year: 'السنة',
    reportOptions: 'خيارات العرض',
    reportLevel: 'المستوى (Level)',
    showZeroBalance: 'إظهار الحسابات الصفرية',
    viewReport: 'عرض التقرير',
    financialStatements: 'القوائم المالية',
    detailedAccountReports: 'تقارير الحسابات التفصيلية',
    taxAndCustomerReports: 'تقارير الضرائب والعملاء',
    trial_balance_desc: 'ميزان المراجعة بالأرصدة والمجاميع حسب المستويات الشجرية',
    pnl_desc: 'قائمة الدخل - بيان الربح والخسارة للفترة المالية المحددة',
    balance_sheet_desc: 'قائمة المركز المالي - الأصول والخصوم وحقوق الملكية',
    cash_flow_desc: 'كشف التدفقات النقدية (المقبوضات والمدفوعات لجميع الصناديق)',
    accountStatement: 'كشف حساب',
    account_statement_desc: 'حركة حساب محدد مع الرصيد الافتتاحي والرصيد اللاحق لكل عملية',
    general_journal_desc: 'كشف القيود التفصيلي لجميع الحركات المحاسبية مرتبة زمنياً',
    expenseAnalysis: 'تحليل المصروفات',
    expense_analysis_desc: 'عرض تفصيلي لجميع المصاريف مصنفة حسب حساب المصروف الرئيسي',
    tax_report_desc: 'مسودة الإقرار الضريبي الرسمي متضمنة ضريبة المخرجات والمدخلات',
    agingReceivable: 'أعمار الديون',
    aging_receivable_desc: 'تحليل أرصدة العملاء المتأخرة حسب الفترة (30-60-90+ يوم)',
    reportsGuide: 'دليل التقارير المحاسبية',
    reportsGuideSubtitle: 'اختر التقرير المناسب لمراجعة أداء مطعمك المالي بدقة.',
    backToGuide: 'العودة للدليل',
    generalLedger: 'دفتر الأستاذ العام',
    general_ledger_desc: 'ملخص جميع الحسابات مع الأرصدة الافتتاحية والمدين والدائن والرصيد الختامي',
    accountLedgerDetail: 'دفتر الأستاذ التفصيلي',
    account_ledger_detail_desc: 'كشف حركة حساب محدد مع الرصيد التراكمي لجميع العمليات',
    cumulativeBalance: 'الرصيد التراكمي',
    finalBalance: 'الرصيد الختامي',
    reportDetails: 'تفاصيل التقرير',
    standardFinancialReports: 'القوائم المالية الأساسية',
    transactionDescription: 'وصف العملية',
    transactionDate: 'تاريخ العملية',
    opening: 'افتتاحي',
    movement: 'الحركة',
    closing: 'إغلاق',
    details: 'Details / التفاصيل',
    runningBalance: 'الرصيد',
    expenseBreakdownDetailed: 'تفاصيل المصروفات حسب الحساب',
    agingReceivables: 'أعمار ديون العملاء',
    days: 'يوم',
    total: 'الإجمالي',
    vat: 'الضريبة',
    totalSales: 'إجمالي المبيعات',
    totalPurchases: 'إجمالي المشتريات',
    netVatDue: 'صافي الضريبة المستحقة',
    vatPayable: 'مبلغ واجب السداد للهيئة',
    vatRefundable: 'رصيد دائن (استرداد)',
    standardVatSales: 'المبيعات الخاضعة للنسبة الأساسية (15%)',
    zeroVatSales: 'المبيعات الصفرية (0%)',
    exemptSales: 'المبيعات المعفاة',
    standardVatPurchases: 'المشتريات الخاضعة للنسبة الأساسية (15%)',
    zeroVatPurchases: 'المشتريات الصفرية (0%)',
    exemptPurchases: 'المشتريات المعفاة',
    error_fetching_report: 'فشل تحميل التقرير، تأكد من الاتصال بالخادم',

    // Vouchers
    vouchersTitle: 'السندات المحاسبية',
    addVoucher: 'إضافة سند',
    searchByStatus: 'بحث حسب الحالة',
    voucherType: 'نوع السند',
    vouchersTable_no: 'رقم السند',
    vouchersTable_type: 'النوع',
    vouchersTable_date: 'التاريخ',
    vouchersTable_amount: 'المبلغ',
    vouchersTable_status: 'الحالة',
    vouchersTable_contact: 'الجهة / الاسم',
    vouchersTable_account: 'الحساب',
    vouchersTable_actions: 'إجراءات',
    receiptVoucher: 'سند قبض',
    paymentVoucher: 'سند صرف',
    receivedFrom: 'استلمنا من',
    paidTo: 'صرفنا لـ',
    onAccountOf: 'وذلك عن',
    paymentMethod: 'طريقة الدفع',
    stamp: 'الختم',
    saveAsDraft: 'حفظ كمسودة',
    postVoucher: 'حفظ وترحيل السند',
    saving: 'جاري الحفظ...',
    referenceNumberLabel: 'رقم المرجع',
    openingBalance: 'الرصيد الافتتاحي',
    ref: 'المرجع',
    costCenter: 'مركز التكلفة',
    code: 'الكود',
    netIncome: 'صافي الربح',
    retainedEarnings: 'الأرباح المبقاة',
    depositInto: 'استلام في حساب (الخزينة/البنك)',
    withdrawFrom: 'صرف من حساب (الخزينة/البنك)',
    sourceAccount: 'حساب الإيراد / المصدر',
    beneficiaryAccount: 'حساب المصروف / المستفيد',
    contactNameLabel: 'الجهة / الاسم (اختياري)',
    descriptionLabel: 'البيان / الوصف',
    confirmPostVoucher: 'هل أنت متأكد من ترحيل هذا السند؟ لا يمكن التراجع عن هذه العملية.',
    noVouchers: 'لا توجد سندات',
    newVoucher: 'إنشاء سند جديد',

    // Cheques
    chequesTitle: 'إدارة الشيكات',
    addCheque: 'إضافة شيك',
    chequeIn: 'شيك وارد (قبض)',
    chequeOut: 'شيك صادر (صرف)',
    chequeNumber: 'رقم الشيك',
    dueDate: 'تاريخ الاستحقاق',
    issueDate: 'تاريخ الإصدار',
    bankName: 'اسم البنك',
    payeeName: 'المستفيد / السحب من',
    chequeStatus: 'حالة الشيك',
    pending: 'تحت التحصيل',
    collected: 'تم التحصيل',
    cleared: 'تم الصرف',
    deposited: 'تم الإيداع',
    bounced: 'مرتجع / مرفوض',
    cancelled: 'ملغي',
    createJournalEntry: 'إنشاء قيد تلقائي',
    updateStatus: 'تحديث الحالة',
    confirmStatusUpdate: 'تأكيد تحديث الحالة',
    noCheques: 'لا توجد شيكات مسجلة',

    // Reconciliation
    bankReconciliation: 'المطابقة البنكية',
    startReconciliation: 'بدء مطابقة جديدة',
    statementBalance: 'الرصيد البنكي',
    systemBalance: 'الرصيد الدفتري',
    match: 'مطابقة',
    adjust: 'تسوية',
    reconciliationSessions: 'جلسات المطابقة',
    openSession: 'جلسة مفتوحة',
    closedSession: 'جلسة مكتملة',
    uploadStatement: 'رفع كشف الحساب (Excel)',
    matchSystemEntry: 'ربط مع قيد في النظام',
    createAdjustment: 'إنشاء قيد تسوية',
    targetAccount: 'الحساب المقابل',
    reconciliationSuccess: 'تمت المطابقة بنجاح',
    unmatchedStatementLines: 'عمليات غير مطابقة في الكشف',
    unmatchedSystemLines: 'عمليات غير مطابقة في النظام',

    // Manual Entries
    newEntry: 'قيد يومية جديد',
    entryDescription: 'شرح القيد الإجمالي',
    chooseAccountFirst: 'يرجى اختيار الحساب لجميع الأسطر',

    // Guide
    accountingGuideTitle: 'دليل النظام المحاسبي المتكامل',
    guide_coa_title: 'شجرة الحسابات (COA)',
    guide_coa_desc:
        'قم ببناء هيكل حساباتك (أصول، خصوم، إيرادات، مصروفات). يمكنك استخدام "تثبيت الافتراضيات" للبدء سريعاً.',
    guide_vouchers_title: 'السندات والقيود',
    guide_vouchers_desc:
        'سجل حركاتك المالية يدوياً عبر قيود اليومية أو استخدم السندات (قبض، صرف) لتوثيق العمليات النقدية.',
    guide_costs_title: 'مراكز التكلفة',
    guide_costs_desc: 'اربط أقسام مطعمك بمراكز تكلفة محددة لتعرف ربحية كل قسم بشكل دقيق ومنفصل.',
    guide_reports_title: 'التقارير المالية',
    guide_reports_desc:
        'استخرج ميزان المراجعة، قائمة الدخل، ودفتر الأستاذ في أي وقت لمراقبة أداء منشأتك المالي.',
    tip_auto_entries:
        'النظام يقوم بإنشاء قيود تلقائية عند إتمام المبيعات إذا تم ضبط إعدادات التوجيه المحاسبي.',
    tip_reverse_entry:
        'ميزة "عكس القيد" تسمح لك بتصحيح الأخطاء المحاسبية بضغطة زر مع الحفاظ على سجل المراجعة.',
    tip_cost_center:
        'فرض "مركز التكلفة" على الحسابات يضمن لك عدم تسجيل أي مصروف دون تخصيصه لمكانه الصحيح.',
    sfda_records_years:
        'يجب الاحتفاظ بسجلات المحاسبة لمدة لا تقل عن 5 سنوات للامتثال لمتطلبات هيئة الزكاة والدخل.',
    sfda_vat_link:
        'القيود المحاسبية تترابط تلقائياً مع الفواتير الإلكترونية لضمان مطابقة الإقرارات الضريبية.',
    // Settings Tab
    generalSettings: 'الإعدادات العامة',
    fiscalYearClosing: 'إغلاق السنة المالية',
    lockDate: 'تاريخ إغلاق الفترة',
    lockDateHint: 'لن يُسمح بأي قيود قبل هذا التاريخ',
    closeYearButton: 'بدء إجراءات الإغلاق',
    defaultAccounts: 'الحسابات الافتراضية',
    salesAccount: 'حساب المبيعات',
    cashAccount: 'حساب الصندوق',
    bankAccount: 'حساب البنك',
    taxAccount: 'حساب الضريبة',
    inventoryAccount: 'حساب المخزون',
    cogsAccount: 'حساب تكلفة البضاعة',
    defaultAccountsHint: 'قم بربط الحسابات الافتراضية هنا ليتم إنشاء القيود المحاسبية تلقائياً.',
    closeFiscalYear: 'إقفال السنة المالية',
    closeYearDesc: 'إقفال حسابات قائمة الدخل (الإيرادات والمصروفات) وترحيل صافي النتيجة إلى حساب الأرباح المبقاة',
    startClosing: 'بدء إجراءات الإقفال',
    confirmCloseYear: 'هل أنت متأكد من إغلاق السنة المالية؟ لا يمكن التراجع عن هذا الإجراء.',
    closeYearSuccess: 'تم إغلاق السنة المالية بنجاح!',
    fillAllFields: 'الرجاء ملء جميع الحقول المطلوبة',
    closeYearWarning: 'سيتم إنشاء قيد آلي لتصفير جميع حسابات قائمة الدخل.',
    closeYearConfirm:
        'تحذير: هذه العملية ستقوم بتصفير جميع حسابات الإيرادات والمصروفات وترحيل الصافي إلى الأرباح المبقاة. هل أنت متأكد؟',

    // Advanced Accounting Tools
    manageFiscalPeriods: 'إدارة الفترات المالية',
    openPeriod: 'فتح فترة مالية',
    openPeriodDesc: 'إعادة فتح فترة مالية مغلقة للتعديل',
    accountingTools: 'أدوات محاسبية متقدمة',
    toolsSubtitle: 'عمليات الصيانة وإعادة الترصيد',
    recalculateBalances: 'إعادة احتساب الأرصدة',
    recalculateDesc: 'تحديث أرصدة الحسابات بناءً على القيود',
    auditLog: 'سجل التدقيق',
    transferBalances: 'نقل أرصدة',
    transferDesc: 'تحويل رصيد من حساب لحساب آخر',
    generalConfiguration: 'تهيئة النظام',
    vatRate: 'نسبة الضريبة الافتراضية (%)',
    currency: 'العملة الأساسية',
    backupData: 'نسخ احتياطي للبيانات',
    confirmRecalculate:
        'هل أنت متأكد؟ سيتم إعادة حساب جميع الأرصدة من الصفر. قد تستغرق العملية دقائق.',
    transferSuccess: 'تم نقل الرصيد بنجاح',
    fromAccount: 'من حساب',
    toAccount: 'إلى حساب',
    welcomeTitle: 'المحاسبة الذكية',
    welcomeBody: 'إدارة مالية متكاملة تشمل القيود، السندات، والشيكات.',
    none: 'بدون',
    main: 'رئيسي',
    sub: 'فرعي',
    nature: 'الطبيعة',
    classification: 'التصنيف',
    descriptionEn: 'الاسم الإنجليزي',
    stopAccount: 'إيقاف (أرشفة)',
    enforceBranch: 'فرض الفرع',
    enforceCostCenter: 'فرض مركز التكلفة',
    chartTree: 'شجرة الحسابات',
    new: 'جديد',
    noAccounts: 'لا توجد حسابات',
    installDefaults: 'تثبيت شجرة الحسابات الافتراضية',
    linkedCategories: 'الأقسام المرتبطة',
    noCategories: 'لا توجد أقسام',
    halkAnalytics: 'تحليل وتقرير الهالك',
    physicalCount: 'الجرد الفيزيائي',

    // Additional Keys
    resetBalance: 'إعادة الترصيد',
    closingDate: 'تاريخ الإغلاق',
    retainedEarningsAccount: 'حساب الأرباح المبقاة',
    confirmClose: 'تأكيد الإغلاق',
    usageGuide: 'دليل الاستخدام',
    guide_step1_title: '1. إعداد شجرة الحسابات',
    guide_step1_desc: 'قم بإنشاء الحسابات الرئيسية والفرعية لتصنيف معاملاتك المالية بشكل صحيح.',
    guide_step2_title: '2. ربط الحسابات الافتراضية',
    guide_step2_desc:
        'من شاشة الإعدادات، اربط حسابات المبيعات والصندوق والبنك لتمكين القيود الآلية.',
    guide_step3_title: '3. إدخال الأرصدة الافتتاحية',
    guide_step3_desc: 'استخدم قيد يومية لإثبات الأرصدة الافتتاحية عند بدء العمل على النظام.',
    guide_step4_title: '4. السندات والقيود',
    guide_step4_desc: 'سجل سندات الصرف والقبض والقيود اليومية للمعاملات غير التلقائية.',
    guide_step5_title: '5. التقارير والإقرارات',
    guide_step5_desc: 'استخرج ميزان المراجعة والإقرارات الضريبية بانتظام لمتابعة الأداء المالي.',
    // Accounting Reports Guide
    generalJournal: 'دفتر اليومية العام',
    reportsHistory: 'سجل التقارير',
    showZero: 'إظهار الأرصدة الصفرية',
    apply: 'تطبيق',
    period: 'الفترة',
    generatedOn: 'تاريخ الإصدار',
    restaurantName: 'اسم المنشأة',
    taxNumber: 'الرقم الضريبي',
    commercialReg: 'السجل التجاري',
    noTableFound: 'لم يتم العثور على بيانات للتصدير',
    account: 'الحساب',
    // Asset Management
    assetsManagement: 'الأصول الثابتة',
    addAsset: 'إضافة أصل',
    assetName: 'اسم الأصل',
    purchaseDate: 'تاريخ الشراء',
    purchaseCost: 'تكلفة الشراء',
    usefulLife: 'العمر الافتراضي (شهور)',
    salvageValue: 'قيمة الخردة',
    runDepreciation: 'تشغيل الإهلاك',
    depreciationSuccess: 'تم تشغيل الإهلاك بنجاح',

    // Payroll
    payroll: 'الرواتب',
    runPayroll: 'إصدار مسير الرواتب',
    employee: 'الموظف',
    basicSalary: 'الراتب الأساسي',
    netSalary: 'صافي الراتب',

    // Tables Page
    tablesManagement: 'إدارة الطاولات',
    tablesSubtitle: 'صمم مخطط مطعمك أو أدر الطاولات كقائمة.',
    visualLayout: 'المخطط البصري',
    listMode: 'القائمة',
    saveLayout: 'حفظ المخطط',
    addTable: 'طاولة جديدة',
    available: 'متاح',
    occupied: 'مشغول',
    capacity: 'السعة',
    tableName: 'اسم/رقم الطاولة',
    shape: 'الشكل',
    width: 'العرض (px)',
    height: 'الطول (px)',
    roundedSquare: 'مربع',
    circle: 'دائري',
    rectangle: 'مستطيل',
    showQr: 'عرض QR',
    preview: 'معاينة',
    dragToMove: 'اسحب لتحريك الطاولات • انقر مرتين للتعديل',
    emptySpace: 'المساحة فارغة',
    emptySpaceSubtitle: 'أضف طاولات وابدأ برسم مخطط المطعم',
    noTables: 'لا توجد طاولات',
    scanQr: 'امسح الرمز لعرض القائمة',
    saveImage: 'حفظ الصورة',
    deleteTableConfirm: 'هل أنت متأكد من حذف',
    layoutSaved: 'تم حفظ مخطط الطاولات بنجاح!',
    layoutSaveError: 'فشل في حفظ المخطط',
    editTable: 'تعديل الطاولة',

    // Customers Page
    customersManagement: 'إدارة العملاء',
    customersSubtitle: 'إدارة الملفات المالية للعملاء والحدود الائتمانية.',
    searchPlaceholder: 'بحث بالاسم أو البريد الإلكتروني...',
    noCustomers: 'لا توجد عملاء',
    noCustomersFound: 'لم يتم العثور على نتائج مطابقة.',
    editFinancialData: 'تعديل البيانات المالية',
    editFinancialDataTitle: 'تعديل البيانات المالية:',
    openingBalanceWarning:
        'ملاحظة: تعديل الرصيد الافتتاحي يجب أن يتم عبر قيد افتتاحي في النظام المحاسبي لضمان التوازن.',
    creditLimitLabel: 'الحد الائتماني (ر.س)',
    notAvailable: 'غير متوفر',

    // Dashboard
    goodMorning: 'صباح الخير',
    hello: 'أهلاً بك',
    viewLiveMenu: 'عرض المنيو المباشر',
    todaysOrders: 'طلبات اليوم',
    pendingOrders: 'طلبات معلقة',
    todaysRevenue: 'مبيعات اليوم',
    completedOrders: 'طلبات مكتملة',
    currentOrders: 'الطلبات الحالية',
    newOrdersWillAppearHere: 'الطلبات الجديدة ستظهر هنا تلقائياً',
    noRecentOrders: 'لا توجد طلبات حديثة',

    // Orders Page
    orderManagement: 'إدارة الطلبات',
    orderManagementSubtitle: 'تتبع، أدر، ونفّذ جميع طلباتك من مكان واحد.',
    searchOrders: 'ابحث باسم العميل أو رقم الطلب...',
    all: 'الكل',
    preparing: 'قيد التحضير',
    completed: 'مكتمل',
    page: 'صفحة',
    of: 'من',
    noOrdersFound: 'لم يتم العثور على طلبات',
    tryChangingFilters: 'حاول تغيير الفلاتر أو مصطلح البحث.',
    orderDetails: 'تفاصيل الطلب',
    customer: 'العميل',
    table: 'الطاولة',
    guestCustomer: 'عميل زائر',
    notSpecified: 'غير محدد',
    orderedItems: 'الأصناف المطلوبة',
    unknownProduct: 'منتج غير معروف',
    noItems: 'لا توجد أصناف في هذا الطلب',
    generalNotes: 'ملاحظات عامة',
    changeStatus: 'تغيير حالة الطلب:',
    printInvoice: 'طباعة الفاتورة',
    print: 'طباعة',
    saveChanges: 'حفظ التغييرات',
    errorUpdateStatus: 'فشل تحديث الحالة',

    // Vendor Layout / Sidebar
    appName: 'DFOOD',
    salesReports: 'نظرة عامة (التقارير)',
    customers: 'العملاء',
    purchases: 'المشتريات',
    purchasesReports: 'نظرة عامة (التقارير)',
    purchaseInvoices: 'فواتير المشتريات',
    strategicReports: 'التقارير الإستراتيجية',
    advancedReports: 'التقارير المتقدمة',
    suppliers: 'إدارة الموردين',
    inventory: 'إدارة المخزون',
    menu: 'إدارة القائمة',
    tables: 'إدارة الطاولات',
    staff: 'إدارة الموظفين',
    loyalty: 'برنامج الولاء',
    logout: 'تسجيل الخروج',
    tablesLayout: 'مخطط الطاولات',
    batchManagement: 'إدارة الدفعات (Quality)',
    haccpChecks: 'تدقيق سلامة الغذاء (HACCP)',
    updating: 'جاري التحديث...',
    refresh: 'تحديث',
    installApp: 'تحميل التطبيق',
    manageProfile: 'إدارة بياناتك',
    backToAdmin: 'العودة للوحة الإدارة',

    // Menu Page
    menuManagement: 'إدارة القائمة',
    menuManagementSubtitle: 'نظم أصناف ومنتجات مطعمك من هنا.',
    addCategory: 'إضافة قسم جديد',
    emptyMenu: 'قائمتك فارغة!',
    emptyMenuSubtitle:
        'ابدأ بإضافة أصناف قائمتك (مثل: المقبلات، الأطباق الرئيسية) ثم قم بإضافة المنتجات.',
    addFirstCategory: 'إضافة أول صنف',
    editCategory: 'تعديل الصنف',
    deleteCategoryConfirm: 'هل أنت متأكد من حذف صنف؟ سيتم حذف جميع المنتجات بداخله.',
    addProduct: 'إضافة منتج جديد',
    editProduct: 'تعديل المنتج',
    deleteProductConfirm: 'هل أنت متأكد من حذف هذا المنتج؟',
    productInfo: 'بيانات المنتج',
    ingredientsInventory: 'المكونات والمخزون',
    name: 'الاسم',
    magicDescription: 'وصف سحري',
    typeDescription: 'اكتب وصفاً للطبق أو استخدم الوصف السحري...',
    price: 'السعر',
    spicy: 'حار',
    vegan: 'نباتي',
    featured: 'مميز',
    image: 'الصورة',
    product: 'المنتج',
    category: 'الصنف',
    orUseAI: 'أو اختر من الوسائل الذكية أدناه:',
    generating: 'جاري التوليد...',
    generateWithAI: 'توليد بالذكاء الاصطناعي',
    searchInternet: 'بحث في الإنترنت',
    inventoryHint:
        'قم بربط هذا المنتج (الطبق) بمكوناته من المخزون. سيتم خصم الكميات من المخزون عند بيع هذا المنتج.',
    loadingItems: 'جاري تحميل الأصناف...',
    chooseItem: 'اختر المكون...',
    quantity: 'الكمية',
    gram: 'جرام',
    kg: 'كيلو',
    pcs: 'قطعة',
    ml: 'مل',
    liter: 'لتر',
    addIngredient: 'إضافة مكون',
    unavailable: 'غير متوفر',
    stock: 'مخزون',
    addNewProduct: 'إضافة منتج جديد',
    noProductsInCategory: 'لا توجد منتجات في هذا الصنف بعد.',
    enterProductNameAI: 'الرجاء إدخال اسم المنتج أولاً لتوليد صورة مناسبة',
    enterProductName: 'يرجى إدخال اسم الطبق أولاً',
    units: 'الوحدات',
    saveError: 'فشل في عملية الحفظ.',
    deleteError: 'فشل في عملية الحذف.',

    // Menu Import / Export
    menuImportExport: 'استيراد / تصدير المنيو',
    importFromExcel: 'استيراد من ملف',
    exportToExcel: 'تصدير للملف',
    downloadTemplate: 'تحميل قالب فارغ',
    downloadTemplateDesc: 'حمّل ملف CSV فارغ بالأعمدة الصحيحة واملأه ببيانات أصنافك',
    importMenuTitle: 'استيراد الأصناف من ملف CSV',
    importMenuDesc: 'ارفع ملف CSV يحتوي على أصنافك ومنتجاتك. يمكنك تحميل القالب الفارغ أولاً.',
    importMode: 'طريقة الاستيراد',
    importModeMerge: 'دمج (إضافة وتحديث)',
    importModeMergeDesc: 'يضاف الجديد ويُحدَّث الموجود بنفس الاسم',
    importModeReplace: 'استبدال كامل',
    importModeReplaceDesc: 'حذف جميع الأصناف الحالية واستبدالها بالملف الجديد',
    replaceWarning: '⚠️ تحذير: هذا الخيار سيحذف جميع الأصناف والمنتجات الحالية نهائياً!',
    chooseFile: 'اختر ملف CSV',
    changeFile: 'تغيير الملف',
    selectedFile: 'الملف المحدد',
    fileSize: 'الحجم',
    startImport: 'بدء الاستيراد',
    importing: 'جاري الاستيراد...',
    importSuccess: 'تم الاستيراد بنجاح!',
    importResults: 'نتائج الاستيراد',
    categoriesCreated: 'أقسام جديدة',
    productsCreated: 'منتجات جديدة',
    productsUpdated: 'منتجات مُحدَّثة',
    rowsProcessed: 'صفوف معالجة',
    importErrors: 'أخطاء',
    rowNumber: 'سطر',
    exportingMenu: 'جاري تصدير المنيو...',
    exportSuccess: 'تم تصدير المنيو بنجاح!',
    noMenuToExport: 'لا توجد أصناف لتصديرها. أضف أصنافاً أولاً.',
    importConfirmReplace: 'هل أنت متأكد من استبدال جميع الأصناف؟ هذا الإجراء لا يمكن التراجع عنه.',
    templateDownloaded: 'تم تحميل القالب',

    // Settings Page
    generalIdentity: 'هوية المطعم',
    branches: 'الفروع',
    paymentMethods: 'الدفع',
    printerSettings: 'إعدادات الطابعة',
    notifications: 'التنبيهات',
    restaurantLogo: 'شعار المطعم',
    logoHint:
        'هذا الشعار سيظهر للزبائن في أعلى المنيو الرقمي. ننصح باستخدام صورة واضحة بدقة عالية (يدعم حتى 10 ميجا).',
    changeLogo: 'تغيير الصورة',
    email: 'البريد الإلكتروني',
    phone: 'هاتف المطعم',
    address: 'العنوان',
    aboutRestaurant: 'عن المطعم (وصف قصير)',
    usd: 'دولار',
    timezone: 'المنطقة الزمنية',
    restaurantBranches: 'فروع المطعم',
    branchesSubtitle: 'قم بإضافة وإدارة فروع مطعمك المختلفة.',
    addBranch: 'إضافة فرع',
    active: 'نشط',
    inactive: 'غير نشط',
    noBranches: 'لا توجد فروع مضافة حالياً',
    paymentSubtitle:
        'قم بتفعيل وسائل الدفع التي ترغب في توفيرها لزبائنك وربط مفاتيح API الخاصة بك.',
    cashPayment: 'الدفع عند الطاولة / كاش',
    apiRequired: 'يتطلب ربط API المباشر',
    printSettingsTitle: 'إعدادات الطباعة والفواتير',
    printSettingsSubtitle:
        'تخصيص تصميم الفاتورة، إعداد الطابعات الحرارية، والتحكم في المحتوى المطبوع.',
    connectionSettings: 'إعدادات الاتصال',
    printerType: 'نوع الطابعة',
    noPrinter: 'بدون طابعة (تنزيل PDF فقط)',
    browserPrint: 'طابعة النظام الافتراضية (Browser Print)',
    networkPrint: 'طابعة شبكية (Network IP)',
    printerIp: 'عنوان IP الطابعة',
    printerPort: 'رقم المنفذ (Port)',
    autoPrintOrder: 'طباعة تلقائية عند قبول الطلب',
    invoiceDesign: 'تصميم الفاتورة',
    thermalReceipt: 'إيصال حراري (POS 80mm)',
    standardInvoice: 'فاتورة قياسية (A4 PDF)',
    invoiceFooter: 'نص تذييل الفاتورة (Footer)',
    showLogoInvoice: 'إظهار الشعار في الفاتورة',
    showQrInvoice: 'إظهار رمز QR للفاتورة الإلكترونية',
    soon: 'قريباً',
    advancedNotifications: 'إدارة متقدمة للتنبيهات',
    imageTooLarge: 'حجم الشعار كبير جداً. يرجى اختيار صورة أقل من 5 ميجابايت.',
    saveBranchError: 'فشل في حفظ بيانات الفرع',
    deleteBranchConfirm: 'هل أنت متأكد من حذف هذا الفرع؟',
    deleteBranchError: 'فشل في حذف الفرع',
    editBranch: 'تعديل بيانات الفرع',
    branchName: 'اسم الفرع',
    branchEmail: 'البريد الإلكتروني للفرع',
    showOnInvoice: 'إظهار هذه المعلومات في فاتورة العميل',
    enableBranch: 'تفعيل الفرع (يظهر للعملاء)',
    officialReport: 'تقرير رسمي',
    financialStatement: 'قائمة مالية',
    dateRange: 'نطاق التاريخ',
    closingBalance: 'الرصيد الختامي',
    voucher: 'سند',

    // Sales Reports
    salesReportsTitle: 'تقارير المبيعات والعملاء',
    salesReportsSubtitle: 'تحليل شامل للمبيعات، الورديات، وديون العملاء.',
    avgOrder: 'متوسط الطلب',
    numOrders: 'عدد الطلبات',
    dailySales: 'المبيعات اليومية',
    topProducts: 'المنتجات الأكثر مبيعاً',
    soldQty: 'الكمية المباعة',
    percentage: 'النسبة',
    shiftsHistory: 'سجل الورديات',
    invoiceSearch: 'بحث الفواتير',
    agingReportTab: 'أعمار الديون',
    shiftNumber: 'رقم الوردية',
    startTime: 'وقت البدء',
    endTime: 'وقت الانتهاء',
    status: 'الحالة',
    openingCash: 'الافتتاحي',
    expectedCash: 'المتوقع',
    actualCash: 'الفعلي',
    actions: 'إجراءات',
    noShiftsFound: 'لا توجد سجلات ورديات في هذه الفترة',
    searchShiftHint: 'أدخل رقم الوردية للبحث في الطلبات المرتبطة...',
    printReport: 'طباعة التقرير',
    invoiceNumber: 'رقم الفاتورة',
    time: 'الوقت',
    noInvoicesFound: 'لا توجد فواتير لهذه الوردية',
    searchShiftPrompt: 'أدخل رقم الوردية للبحث',
    days31_60: '31-60',
    days61_90: '61-90',
    days90_plus: '+90',
    totalDue: 'الإجمالي',

    // Inventory Page
    smartInventory: 'إدارة المخزون الذكية',
    smartInventorySubtitle: 'تتبع دقيق، تنبيهات ذكية، وتحكم كامل في مستودعك.',

    // Sidebar & Vendor Layout
    returnsHistory: 'سجل المرتجعات',
    reputationManagement: 'إدارة السمعة والعملاء',
    sfdaCompliance: 'الامتثال لهيئة الغذاء والدواء',
    trainingRecords: 'سجلات التدريب',
    rawMaterials: 'المواد الأولية',
    warehouses: 'المستودعات',
    replenishment: 'إعادة التوريد',
    stockAlerts: 'تنبيهات النواقص',
    inventoryReports: 'تقارير المخزون',

    // Purchase Returns Page
    purchaseReturnsManagement: 'إدارة مرتجعات المشتريات',
    purchaseReturnsSubtitle: 'إدارة وتتبع مرتجعات المشتريات مع تحديث المخزون',
    createNewReturn: 'إنشاء مرتجع جديد',
    availableInvoices: 'الفواتير المتاحة للارجاع',
    availableInvoicesSubtitle: 'يمكن إرجاع الفواتير المدفوعة خلال فترة السماح',
    createReturn: 'إنشاء مرتجع',
    noInvoicesForReturn: 'لا توجد فواتير متاحة للإرجاع',
    returnDate: 'تاريخ الإرجاع',
    returnReason: 'سبب الإرجاع',
    selectReason: 'اختر السبب',
    defective: 'منتج معيب',
    wrongItem: 'صنف خاطئ',
    excessQuantity: 'كمية زائدة',
    expired: 'منتهي الصلاحية',
    damaged: 'تالف',
    qualityIssue: 'مشكلة في الجودة',
    other: 'أخرى',
    selectItemsToReturn: 'اختر الأصناف المراد إرجاعها',
    originalQty: 'الكمية الأصلية',
    returnQty: 'كمية الإرجاع',
    returnTotal: 'إجمالي المرتجع',
    confirmReturn: 'تأكيد الإرجاع',
    returnCreatedSuccess: 'تم إنشاء مرتجع المشتريات بنجاح!',
    returnCreatedNote: 'تم تحديث المخزون وإصدار إشعار دائن.',
    selectAtLeastOneItem: 'الرجاء اختيار صنف واحد على الأقل للإرجاع',
    enterReturnReason: 'الرجاء إدخال سبب الإرجاع',
    failedToCreateReturn: 'فشل إنشاء المرتجع',

    // Customers Page
    addCustomer: 'إضافة عميل',
    customerName: 'اسم العميل',
    customerEmail: 'البريد الإلكتروني',
    customerPhone: 'الجوال',
    marketing: 'التسويق',
    country: 'الدولة',
    region: 'المنطقة',
    city: 'المدينة',
    district: 'الحي',
    buildingNumber: 'رقم المبنى',
    street: 'الشارع',
    postalCode: 'الرمز البريدي',
    contactPerson: 'الشخص المسؤول',
    website: 'الموقع الإلكتروني',
    fax: 'الفاكس',
    priceLevel: 'مستوى السعر',
    standard: 'قياسي',
    vip: 'VIP',
    wholesale: 'جملة',
    paymentPeriod: 'فترة السداد (أيام)',
    isActive: 'نشط',
    saveCustomerSuccess: 'تم حفظ العميل بنجاح',
    updateCustomerSuccess: 'تم تحديث العميل بنجاح',
    general: 'عام',
    addressDetails: 'العنوان والتفاصيل',
    totalPayments: 'إجمالي المدفوعات',
    // Delivery Integrations
    deliveryIntegrations: 'ربط تطبيقات التوصيل',
    integrationsSubtitle: 'إدارة الربط مع منصات التوصيل الخارجية',
    saveSettings: 'حفظ الإعدادات',
    connected: 'متصل',
    disconnected: 'غير متصل',
    autoAcceptOrders: 'قبول الطلبات تلقائياً',
    lastSynced: 'آخر مزامنة',
    queue: 'إدارة الطوابير',
    queueManagement: 'إدارة قوائم الانتظار',
    queueSubtitle: 'تتبع العملاء المنتظرين للطاولات',
    addToQueue: 'إضافة عميل للانتظار',
    waitingNow: 'في الانتظار',
    notified: 'تم الإبلاغ',
    seated: 'تم الجلوس',
    notify: 'إبلاغ',
    partySize: 'عدد الأفراد',
    waitTime: 'وقت الانتظار',
    noWaitingCustomers: 'لا يوجد عملاء في الانتظار حالياً',
    waiting: 'انتظار',

    // Offline Mode
    offlineMode: 'وضع عدم الاتصال',
    youAreOffline: 'أنت الآن غير متصل بالإنترنت',
    offlineDescription:
        'النظام يعمل الآن في وضع عدم الاتصال. يمكنك استلام الطلبات وسيتم مزامنتها تلقائياً عند عودة الاتصال.',
    offlineBadge: 'OFFLINE',
    syncingSoon: 'سيتم المزامنة قريباً...',
    // Delivery Statements & Pricing
    deliveryStatements: 'كشوف حسابات التوصيل',
    deliveryStatementsSubtitle: 'متابعة المبيعات والعمولات لكل تطبيق توصيل',
    pricingRules: 'قواعد التسعير',
    priceMarkup: 'زيادة السعر',
    enableDiscounts: 'تفعيل العروض/الخصم',
    discountPercent: 'نسبة الخصم',
    totalCommissions: 'إجمالي العمولات (تقديري)',
    netDue: 'صافي المستحق',
    orderTotal: 'قيمة الطلب',
    commission: 'العمولة',
    net: 'الصافي',
    orderId: 'رقم الطلب',
    provider: 'التطبيق',
    filter: 'تصفية',
    export: 'تصدير',
    marketingAndScreens: 'التسويق والشاشات Digitial Signage',
    marketingSubtitle: 'إدارة عروضك، شاشات العرض، الكشك، وشاشة العميل',
    marketingGuide: 'دليل التسويق الذكي',
    content: 'المحتوى',
    screens: 'الشاشات',
    customerDisplay: 'شاشة العميل',
    selfKiosk: 'الكشك الذاتي',
    printableMenu: 'منيو للطباعة',
    digitalMarketingGuideTitle: 'دليل التسويق الرقمي والشاشات',
    guide_marketing_step1_title: 'برمجة الشاشات الإعلانية',
    guide_marketing_step1_desc:
        'أضف شاشة جديدة، انسخ الرابط وافتحه في المتصفح الخاص بأي شاشة ذكية. سيتم بث المحتوى فوراً.',
    guide_marketing_step2_title: 'إدارة المحتوى والميديا',
    guide_marketing_step2_desc:
        'ارفع صور العروض أو مقاطع الفيديو وحدد مدة ظهور كل منها لبناء تجربة بصرية ممتعة للعملاء.',
    guide_marketing_step3_title: 'شاشة العميل (CFD)',
    guide_marketing_step3_desc:
        'اربط شاشة ثانية عند الكاشير ليعرض للعملاء تفاصيل طلبهم ورسائل ترحيبية تزيد من ولاء العميل.',
    guide_marketing_step4_title: 'الكشك الذاتي (Self-Kiosk)',
    guide_marketing_step4_desc:
        'خصص واجهة الكشك التفاعلية وصور "الجذب" لدفع العملاء للطلب الذاتي وتخفيف الزحام.',
    guide_marketing_step5_title: 'المنيو المطبوع',
    guide_marketing_step5_desc:
        'صمم منيو ورقي أنيق بضغطة زر مبني على أصناف القائمة الرقمية، جاهز للطباعة الفورية.',
    marketing_tip1: 'استخدم صوراً بدقة 1920x1080 لضمان أفضل وضوح على شاشات التلفزيون الكبيرة.',
    marketing_tip2: 'يمكنك جدولة المحتوى ليظهر في أيام معينة من الأسبوع (مثلاً عروض الجمعة فقط).',
    marketing_tip3: 'تغيير الرابط السري للشاشة يقطع الاتصال عن الأجهزة القديمة لضمان الأمان.',
    marketing_sfda1: 'يجب عدم عرض أي صور تخالف الذوق العام أو الأنظمة المحلية.',
    marketing_sfda2: 'المنيو المطبوع يجب أن يحتوي على كود QR يوجه للنسخة المعتمدة ضريبياً.',
    manageSelfKiosk: 'إدارة الكشك الذاتي (Self-Kiosk)',
    kioskSubtitle: 'تخصيص واجهة الكشك التفاعلية وشاشة الجذب.',
    openKiosk: 'فتح الكشك',
    attractorTitle: 'عنوان شاشة الجذب (العنوان الضخم)',
    attractorTitlePlaceholder: 'مثال: جيعان؟',
    attractorSubtitleLabel: 'النص الفرعي',
    attractorSubtitlePlaceholder: 'مثال: اطلب الآن بلمسة واحدة',
    attractorImages: 'صور الواجهة (روابط الصور - تظهر كعرض شرائح)',
    saveKioskSettings: 'حفظ إعدادات الكشك',
    startOrdering: 'ابدأ الطلب',
    kioskPreview: 'معاينة واجهة الكشك',
    printableMenuDesigner: 'مصمم القوائم المطبوعة',
    printableMenuSubtitle: 'أنشئ قائمة أصناف عصرية ومودرن لمطعمك جاهزة للطباعة أو الحفظ كـ PDF.',
    publishContent: 'نشر المحتوى',
    // Reconciliation Detailed
    newReconciliationSession: 'جلسة مطابقة بنكية جديدة',
    statementBalanceFinal: 'رصيد كشف الحساب (النهائي)',
    bankBalance: 'رصيد البنك',
    ready: 'جاهز',
    selectTwoItems: 'اختر عنصرين للمطابقة',
    bankStatementIn: 'كشف البنك (الوارد)',
    systemLedger: 'دفاتر النظام',
    allMatched: 'لا توجد عناصر غير مطابقة',
    createAdjustmentEntry: 'إنشاء قيد تسوية',
    adjustStatementLineHint: 'أنت بصدد إنشاء قيد جديد لهذا السطر البنكي:',
    chooseAdjustmentAccount: 'اختر الحساب (مثلاً: مصروفات بنكية)',
    confirmAdjustment: 'تأكيد التسوية',
    bankAccountLabel: 'الحساب البنكي',
    noDataToExport: 'لا توجد بيانات للتصدير',
    voucherPostedSuccess: 'تم ترحيل السند بنجاح',
    voucherDraftSuccess: 'تم حفظ السند كمسودة',
    postedSuccess: 'تم الترحيل بنجاح',
    chequeCreatedSuccess: 'تم حفظ الشيك بنجاح',
    clearFilters: 'إلغاء الفلاتر',
    autoEntryNotice: 'سيتم إنشاء قيد محاسبي تلقائي لتوثيق هذه العملية.',
    adjustmentSuccess: 'تم إنشاء القيد ومطابقته',
    pendingChequesIn: 'شيكات تحت التحصيل (وارد)',
    pendingChequesOut: 'شيكات مستحقة الدفع (صادر)',
    openReconciliations: 'مطابقات مفتوحة',
    defaultCoaSuccess: 'تم إنشاء شجرة الحسابات الافتراضية بنجاح',
    failedLoadAccounts: 'فشل تحميل الحسابات',
    chequeStatusUpdated: 'تم تحديث حالة الشيك',
    chequeInShort: 'وارد (قبض)',
    chequeOutShort: 'صادر (صرف)',
    chequeType: 'نوع الشيك',
    analyzingMenu: 'جاري تحليل المنيو بالذكاء الاصطناعي...',
    aiMenuOptimization: 'تحسين المنيو (Menu Optimization)',
    aiMenuSubtitle: 'توصيات ذكية لزيادة الأرباح وتحسين الأداء',
    refreshAnalysis: 'تحديث التحليل',
    pricingRecommendations: 'توصيات الأسعار (Pricing)',
    menuEngineering: 'هندسة المنيو (Engineering)',
    productLifecycle: 'دورة حياة المنتج (Lifecycle)',
    crossSellOpportunities: 'فرص البيع (Cross-Sell)',
    seasonalRecommendations: 'توصيات موسمية (Seasonal)',
    totalProducts: 'إجمالي المنتجات',
    totalProfit: 'إجمالي الأرباح',
    profitMargin: 'هامش الربح',
    topPerformers: 'الأعلى أداءً (Top Performers)',
    analyzedProducts: 'منتجات تم تحليلها',
    needsAdjustment: 'تحتاج تعديل',
    increaseDecrease: 'زيادة / تخفيض',
    aiPricingRecommendations: 'توصيات الأسعار الذكية',
    confidence: 'الثقة',
    high: 'عالية',
    medium: 'متوسطة',
    low: 'منخفضة',
    currentPrice: 'السعر الحالي',
    suggestedPrice: 'السعر المقترح',
    projectedMargin: 'الهامش المتوقع',
    stars: 'نجوم (Stars)',
    starsDesc: 'مبيعات عالية + هامش عالي',
    plowhorses: 'أحصنة (Plowhorses)',
    plowhorsesDesc: 'مبيعات عالية + هامش منخفض',
    puzzles: 'ألغاز (Puzzles)',
    puzzlesDesc: 'مبيعات منخفضة + هامش عالي',
    dogs: 'متراجعة (Dogs)',
    dogsDesc: 'مبيعات منخفضة + هامش منخفض',
    noMenuEngineeringData: 'لا توجد بيانات هندسة منيو',
    checkData: 'تأكد من وجود مبيعات',
    underperformers: 'منتجات ضعيفة الأداء (Underperformers)',
    hiddenGems: 'كنوز مخفية (Hidden Gems)',
    recommendation: 'التوصية (Recommendation)',

    // AI Consultant Page
    ai_title: 'المساعد الإداري الذكي',
    ai_subtitle: 'رؤى استراتيجية مدعومة بالذكاء الاصطناعي لتحسين أداء مطعمك',
    ai_loading: 'جاري تشغيل محرك العقل الاصطناعي...',
    ai_failedTitle: 'فشل تحميل البيانات',
    ai_failedDesc: 'عذراً، لم نتمكن من جلب تحليلات الذكاء الاصطناعي حالياً. يرجى التأكد من وجود بيانات كافية (طلبات، مبيعات) في مطعمك.',
    ai_retry: 'حاول مرة أخرى',
    ai_healthScore: 'مؤشر الصحة التشغيلية',
    ai_healthGood: 'أداء ممتاز ومخاطر منخفضة',
    ai_healthImprove: 'هناك فرص للتحسين في العمليات',
    ai_topRecommendation: 'أهم توصية استراتيجية',
    ai_noRecommendation: 'لا توجد توصيات حالياً',
    ai_executeNow: 'تنفيذ الآن',
    ai_menuMatrix: 'مصفوفة المنيو (Menu Matrix)',
    ai_items: 'صنف',
    ai_stars: 'النجوم (Stars)',
    ai_starsDesc: 'عالية الربح وشعبية جداً',
    ai_plowhorses: 'الأحصنة (Plowhorses)',
    ai_plowhorsesDesc: 'شعبية لكن ربحها محدود',
    ai_puzzles: 'الألغاز (Puzzles)',
    ai_puzzlesDesc: 'ربح عالٍ وشعبية منخفضة',
    ai_dogs: 'الأصناف المتراجعة (Dogs)',
    ai_dogsDesc: 'ضعيفة الربح والشعبية',
    ai_criticalAnalysis: 'تحليل الأصناف الحرجة',
    ai_peakPerformance: 'أداء ساعات الذروة',
    ai_crowdForecast: 'توقع الازدحام',
    ai_expectedPeak: 'الذروة المتوقعة في الساعة',
    ai_customerVoice: 'صوت العميل',
    ai_positive: 'إيجابي',
    ai_basedOn: 'بناءً على',
    ai_reviews: 'تقييم',
    ai_risksTitle: 'المخاطر والفرص الضائعة',
    ai_lowStock: 'نقص المخزون',
    ai_itemsNeedSupply: 'أصناف تحتاج للتوريد',
    ai_compliance: 'الامتثال والمعايير',
    ai_compliant: 'مطابق بنسبة',
    ai_aiTip: 'نصيحة العقل الاصطناعي:',
    ai_lowStockTip: 'تأمين المخزون هو الأولوية القصوى حالياً لتجنب كسر دورة المبيعات.',
    ai_stockGoodTip: 'كل شيء يبدو رائعاً من حيث المخزون، ركز على تحسين تجربة العميل.',
    ai_strategicRoadmap: 'خارطة الطريق الاستراتيجية',
    ai_demandForecast: 'التنبؤ بالطلب',
    ai_rising: 'صاعد 📈',
    ai_falling: 'تناقصي 📉',
    ai_stable: 'مستقر ↔️',
    ai_next7Days: 'توقعات الـ 7 أيام القادمة',
    ai_orders: 'طلب',
    ai_accuracy: 'دقة',
    ai_forecastNote: '* يعتمد التنبؤ على تحليل أنماط الطلب في الـ 60 يوماً الماضية مع مراعاة أيام الأسبوع.',
    ai_week: 'أسبوع',
    ai_month: 'شهر',
    ai_3months: '3 أشهر',
    ai_chatTitle: 'المستشار المالي (Live)',
    ai_chatWelcome: 'أهلاً بك! أنا مستشارك المالي الذكي. يمكنك سؤالي عن مبيعاتك، رواتبك، أو أي تفاصيل مالية لمطعمك. كيف أساعدك اليوم؟',
    ai_chatError: 'عذراً، حدث خطأ أثناء معالجة طلبك 😔',
    ai_chatPlaceholder: 'اسأل المستشار المالي...',
    ai_guideTitle: 'دليل المساعد الإداري الذكي (AI Insight)',
    ai_guideStep1Title: 'فهم مؤشر الصحة',
    ai_guideStep1Desc: 'يعطيك نظرة سريعة على جودة عملياتك التشغيلية، كلما زاد الرقم كان مطعمك في حالة صحية ممتازة.',
    ai_guideStep2Title: 'المستشار المالي الحي',
    ai_guideStep2Desc: 'استخدم أيقونة الشات في الأسفل لتتحدث مع بياناتك المالية مباشرة باللغة العربية.',
    ai_guideStep3Title: 'توقعات ساعات الذروة',
    ai_guideStep3Desc: 'يحلل النظام الماضي ليتوقع لك مستقبل الضغط لترتب جدول الموظفين وتحضير المكونات مسبقاً.',
    ai_guideStep4Title: 'خارطة الطريق الاستراتيجية',
    ai_guideStep4Desc: 'خطوات عملية مقترحة من الذكاء الاصطناعي لتحسين الربحية وتلافي المخاطر التشغيلية.',
    ai_tip1: 'جرب سؤال المساعد المالي: "كيف كانت مبيعاتي هذا الشهر مقارنة بالشهر السابق؟"',
    ai_tip2: 'اسأل المساعد عن "الرواتب" لتعرف إجمالي المصروفات المالية لشؤون الموظفين.',
    ai_tip3: 'التنبؤ بالطلب يساعدك في تقليل الهادر من المواد الخام بنسبة تصل إلى 20%.',
    ai_dayLabel: 'اليوم',

    // Sidebar Navigation
    sidebar_aiConsultant: 'المساعد الذكي (AI)',
    sidebar_operations: 'العمليات والخدمة',
    sidebar_inventoryMenu: 'المنيو والمخزون',
    sidebar_governance: 'الحوكمة والمالية',
    sidebar_hqConsole: 'المركز الرئيسي (HQ)',
    sidebar_compliance: 'الامتثال والجودة (SFDA)',
    sidebar_marketingGrowth: 'التسويق والعملاء',
    sidebar_technicalAdmin: 'الإدارة والربط',
    sidebar_queueManagement: 'إدارة الطوابير',
    sidebar_waiterApp: 'تطبيق النادل',
    sidebar_recipeCosting: 'تكلفة الوجبات',
    sidebar_lowStockAlerts: 'تنبيهات النواقص',
    sidebar_kioskManagement: 'إدارة الكيوسك',
    sidebar_floorPlan: 'مخطط الصالة',
    sidebar_purchasesGroup: 'إدارة المشتريات',
    sidebar_purchaseInvoices: 'فواتير المشتريات',
    sidebar_purchaseReturns: 'مرتجعات المشتريات',
    sidebar_supplierStatement: 'كشف حساب مورد',
    sidebar_fixedAssets: 'الأصول الثابتة',
    sidebar_payrollHR: 'الرواتب وشؤون الموظفين',
    sidebar_taxDeclaration: 'الإقرار الضريبي',
    sidebar_reportsOverviewSales: 'نظرة عامة التقارير (المبيعات)',
    sidebar_reportsOverviewPurchases: 'نظرة عامة التقارير (المشتريات)',
    sidebar_branchManagement: 'إدارة الفروع',
    sidebar_hqDashboard: 'لوحة التحكم الموحدة',
    sidebar_hqAccountingCenter: 'المركز المالي الموحد',
    sidebar_consolidatedReports: 'تقارير المجموعة',
    sidebar_customers: 'إدارة العملاء',
    sidebar_aiMenuOptimization: 'تحسين المنيو بالذكاء الاصطناعي',
    sidebar_kioskSettings: 'إعدادات الكشك',
    sidebar_integrations: 'الربط مع التطبيقات',
    sidebar_deliveryStatements: 'كشوفات التوصيل',
    sidebar_backupRestore: 'النسخ الاحتياطي والاستعادة',
    sidebar_backup: 'النسخ الاحتياطي',
    sidebar_subscription: 'الاشتراك والباقة',
    sidebar_paymentSettings: 'إعدادات الدفع',
    sidebar_securityPrivacy: 'حالة الأمان والخصوصية',
    sidebar_firewallActive: 'جدار الحماية نشط - محمي بالكامل',
    sidebar_aesEncrypted: 'تشفير AES-256',
    sidebar_lastBackup: 'آخر نسخة احتياطية:',
    sidebar_complianceHealth: 'مركز الصحة والامتثال',
    sidebar_aiDecisionSupport: 'دعم القرار الذكي',
    sidebar_strategicAdvice: 'توصية استراتيجية',
    sidebar_analyzingData: 'نحلل بياناتك حالياً لتقديم أفضل التوصيات...',
    sidebar_viewFullAnalysis: 'عرض التحليل الكامل',
    sidebar_onboardingGuide: 'دليل الانطلاق',
    sidebar_systemHealth: 'درجة الصحة التقنية',
    sidebar_purchaseReports: 'تقارير المشتريات',
    sidebar_advancedReports: 'التقارير المتقدمة الموحدة',
    sidebar_assets: 'إدارة الأصول الثابتة',
    sidebar_trainingRecords: 'سجلات تدريب الموظفين',
    sidebar_complianceAI: 'فحص الامتثال بالذكاء الاصطناعي',
    sidebar_reputation: 'تحليل السمعة والتقييمات',
    sidebar_staffList: 'قائمة الموظفين',
    sidebar_payroll: 'إدارة الرواتب',

    // Dashboard extra keys
    dash_goodMorning: 'صباح الخير',
    dash_goodEvening: 'مساء الخير',
    dash_restaurantPrefix: 'المنشأة:',
    dash_loadingRestaurant: 'جاري الاتصال بنظام المطعم...',
    dash_posLabel: 'المبيعات (POS)',
    dash_smartConsultant: 'ذكاء الإدارة (AI)',
    dash_kitchenDisplay: 'عمليات المطبخ (KDS)',
    dash_financialReports: 'الرؤى المالية',
    dash_tableHeatmap: 'خارطة الإشغال',
    dash_quiet: 'مستقر',
    dash_active: 'طلب مرتفع',
    dash_loadingDashboard: 'فشل النظام في تحميل بيانات لوحة التحكم.',
    dash_optimal: 'مثالي',
    dash_excellent: 'ممتاز',
    dash_techHealth: 'درجة الصحة التقنية',

    // Settings Page Tabs & Sections
    settings_generalSection: 'الهوية الجوهرية',
    settings_menuOrdering: 'نظام الطلب',
    settings_menuSlides: 'بنرات التسويق',
    settings_qrSettings: 'اتصال الـ QR',
    settings_financeOps: 'الضوابط المالية',
    settings_kitchenPrinters: 'خدمات التنبيه والطباعة',
    settings_zatcaLink: 'الامتثال لهيئة الزكاة (ZATCA)',
    settings_otherSection: 'الإدارة العامة',
    settings_dataPrivacy: 'خصوصية البيانات والأمان',
    settings_security2fa: 'الأمان (2FA)',
    settings_help: 'خدمة المساعدة',
    settings_securityTitle: 'إعدادات الأمان المتقدمة',
    settings_securityDesc: 'حماية بيانات منشأتك عبر المصادقة الثنائية',
    settings_setupGuide: 'بروتوكول الربط والإعداد',
    settings_units: 'وحدات القياس',
    settings_restaurantType: 'تصنيف النشاط',
    settings_restaurant: 'مطعم',
    settings_cafe: 'مقهى',
    settings_bakery: 'مخبز / حلويات',
    settings_foodTruck: 'عربة طعام',
    settings_cloudKitchen: 'مطبخ سحابي',
    settings_other: 'أخرى',

    // ZATCA & National Address
    settings_zatcaTitle: 'بيانات الفوترة الإلكترونية (ZATCA)',
    settings_zatcaDesc: 'معلومات التسجيل الضريبي الرسمية',
    settings_zatcaMandatory: 'مقيد / إلزامي',
    settings_zatcaReason: 'لضمان الالتزام بمتطلبات المرحلة الثانية من الفوترة الإلكترونية في المملكة العربية السعودية',
    settings_vatNumber: 'رقم التسجيل الضريبي (VAT)',
    settings_crNumber: 'رقم السجل التجاري (CR)',
    settings_vatHint: '15 رقم، يبدأ بـ 3',
    settings_nationalAddress: 'العنوان الوطني الرسمي',
    settings_buildingNumber: 'رقم المبنى',
    settings_streetName: 'اسم الشارع',
    settings_district: 'الحي',
    settings_city: 'المدينة',
    settings_postalCode: 'الرمز البريدي',
    settings_postalHint: '5 أرقام',
    settings_additionalNumber: 'الرقم الإضافي',
    settings_additionalHint: '4 أرقام',
    settings_deviceSerial: 'الرقم التسلسلي للجهاز (اختياري)',
    settings_timezoneRiyadh: 'نطاق الرياض (GMT+3)',

    // أنواع النشاط
    type_restaurant: 'مطعم',
    type_cafe: 'مقهى',
    type_juice: 'محل عصائر',
    type_bakery: 'مخبز / حلويات',
    type_sweets: 'حلويات',
    type_cafeteria: 'بوفيه / كافتيريا',
    type_food_truck: 'عربة طعام',
    type_other: 'نشاط آخر',

    // Menu Offers / Slides
    settings_menuBannersTitle: 'إدارة بنرات المنيو المميزة',
    settings_menuBannersDesc: 'شرائح تفاعلية تجذب العملاء في الجزء العلوي من القائمة الرقمية الخاصة بك.',
    settings_slideTitle: 'عنوان البنر الرئيسي',
    settings_slideSubtitle: 'العنوان الترويجي الفرعي',
    settings_slideImageUrl: 'رابط صورة البنر',
    settings_addSlide: 'إضافة بنر جديد',
    settings_removeSlide: 'أرشفة',
    settings_noSlides: 'لا يوجد بنرات نشطة حالياً',

    // Dashboard Guide Steps
    dashGuide_title: 'دليل التميز والتشغيل',
    dashGuide_step1Title: 'نبض التشغيل اللحظي',
    dashGuide_step1Desc: 'تابع صحتك المالية من خلال لوحة النبض الحي، التي يتم تحديثها كل 30 ثانية.',
    dashGuide_step2Title: 'قرارات مدفوعة بالذكاء',
    dashGuide_step2Desc: 'يقوم الذكاء الاصطناعي بتحليل الأنماط لاقتراح خطوات لزيادة الربح وتقليل الهدر.',
    dashGuide_step3Title: 'رقابة الامتثال',
    dashGuide_step3Desc: 'تحقق تلقائي من ربط ZATCA وسجلات SFDA لعمليات خالية من القلق.',
    dashGuide_step4Title: 'خارطة العملاء الحية',
    dashGuide_step4Desc: 'تصور معدل دوران الطاولات والإشغال في الوقت الفعلي لتحسين كفاءة الخدمة.',
    dashGuide_tip1: 'استخدم "الإجراءات السريعة" لأكثر المهام الإدارية تكراراً لديك.',
    dashGuide_tip2: 'حالة الصحة باللون "الأخضر" تعني أن بنية عملك التحتية تعمل بكامل طاقتها.',
    dashGuide_tip3: 'تزداد دقة توصيات الـ AI مع توسع تاريخ طلباتك.',
    dashGuide_sfda1: 'تنشئ لوحة التحكم سجلاً تدقيقياً غير قابل للتعديل لعمليات التفتيش الرسمية.',
    dashGuide_sfda2: 'يتم إبراز تنبيهات تتبع الدفعات هنا لتخفيف مخاطر سلامة الأغذية فوراً.',

    // Home Page
    home_hero_title: 'نظام إدارة المطاعم المتكامل الذي يجمع كل ما تحتاجه في مكان واحد',
    home_hero_subtitle: 'منيو، مخزون، نقاط بيع، ومحاسبة – منصة DFOOD تمنح مطعمك قوة التكنولوجيا الحديثة بأبسط الطرق.',
    home_cta_start_free: 'ابدأ تجربتك المجانية الآن (14 يوم)',
    home_cta_demo: 'احجز عرض توضيحي (Demo)',

    home_features_title: 'كل الأدوات لنمو مطعمك',
    home_feature_inventory: 'إدارة المخزون الذكية',
    home_feature_inventory_desc: 'تتبع المكونات بدقة، إدارة تواريخ الانتهاء، والتكامل مع لوائح هيئة الغذاء والدواء.',
    home_feature_delivery: 'ربط تطبيقات التوصيل',
    home_feature_delivery_desc: 'استقبل طلبات جاهز وهنقرستيشن في شاشة واحدة دون تشتت.',
    home_feature_zatca: 'فوترة ZATCA المعتمدة',
    home_feature_zatca_desc: 'إصدار فواتير إلكترونية متوافقة مع المرحلة الثانية لهيئة الزكاة والضريبة.',
    home_feature_ai_menu: 'منيو بالذكاء الاصطناعي',
    home_feature_ai_menu_desc: 'أنشئ وصفاً وصوراً لأطباقك باستخدام AI بلمسة زر.',
    home_feature_kds: 'شاشات المطبخ KDS',
    home_feature_kds_desc: 'نظم الطلبات بين الكاشير والمطبخ وسرع وتيرة العمل.',
    home_feature_loyalty: 'برامج الولاء',
    home_feature_loyalty_desc: 'حافظ على عملائك بنظام نقاط وكوبونات ذكي.',
    home_feature_hr: 'الموارد البشرية وكشوف الرواتب',
    home_feature_hr_desc: 'إدارة الرواتب، الحضور والانصراف، وجداول العمل.',

    home_testimonials_title: 'ماذا يقول عملاؤنا؟',
    home_testimonial1_content: 'باستخدام منصة DFOOD المتكاملة، زادت مبيعاتنا بنسبة 30%. النظام يغطي كل شيء من المحاسبة إلى المخزون بدقة مذهلة.',
    home_testimonial2_content: 'وفرت المنصة الكثير من الوقت والموارد. لم نعد بحاجة لأنظمة محاسبية خارجية، فكل شيء مرتبط ببعضه البعض.',
    home_testimonial3_content: 'نظام الدفع الإلكتروني والتقارير التحليلية غير طريقة عملنا بالكامل. ننصح بها بشدة.',
    home_faq_title: 'الأسئلة الشائعة',
    home_pricing_title: 'باقات تناسب الجميع',

    home_footer_copyright: 'جميع الحقوق محفوظة لمنصة DFOOD © 2026',
    home_nav_features: 'المميزات',
    home_nav_how_it_works: 'كيف يعمل',
    home_nav_pricing: 'الأسعار',
    home_nav_testimonials: 'آراء العملاء',
    home_nav_faq: 'الأسئلة الشائعة',
    home_login: 'تسجيل الدخول',
    home_register: 'فتح حساب جديد',

    home_step1_title: 'سجل حسابك',
    home_step1_desc: 'أدخل بيانات مطعمك وارفع شعارك في أقل من دقيقة.',
    home_step2_title: 'ارفع المنيو',
    home_step2_desc: 'استخدم الذكاء الاصطناعي لإضافة الأطباق وصورها.',
    home_step3_title: 'ابدأ البيع',
    home_step3_desc: 'اطبع QR Code وضعه على الطاولات وابدأ استقبال الطلبات.',
    home_how_it_works_title: 'ابدأ البيع في 3 خطوات بسيطة',
    home_how_it_works_subtitle: 'لا حاجة لخبرة تقنية مسبقة.',

    home_get_started_today: 'ابدأ رحلة التحول الرقمي لمطعمك اليوم',
    home_join_thousands: 'انضم لأكثر من 5000 مطعم يثقون في منصة DFOOD.',
    home_no_credit_card: 'لا تتطلب بطاقة ائتمان للتجربة.',

    home_announcement_promo: 'عرض خاص: احصل على 3 أشهر مجاناً عند الاشتراك السنوي!',
    home_announcement_cta: 'اشترك الآن',

    home_stats_title: 'أرقام تتحدث عن نفسها',
    home_stats_subtitle: 'انضم إلى مئات المطاعم التي تضع ثقتها في تقنياتنا',
    home_stats_restaurants: 'مطعم ومقهى',
    home_stats_orders: 'طلب يومي',
    home_stats_satisfaction: 'نسبة رضا العملاء',
    home_stats_support: 'دعم فني متخصص 24/7',

    home_comparison_subtitle: 'التحول الرقمي',
    home_comparison_title: 'الفرق واضح وملموس في نمو عملك',
    home_comparison_desc: 'شاهد كيف تغير المنصة طريقة عملك بالكامل نحو الأفضل',
    home_comparison_before: 'قبل استخدام المنصة (العمل اليدوي)',
    home_comparison_after: 'مع منصة DFOOD (العمل الذكي)',
    home_comparison_cta: 'ابدأ التحول الرقمي لمطعمك الآن',
    home_comparison_before_1: 'قوائم ورقية تتلف وتحتاج لطباعة وتكاليف مستمرة',
    home_comparison_before_2: 'تكاليف تشغيلية وطباعة عالية تستنزف ميزانيتك',
    home_comparison_before_3: 'وقت طويل ومهدر لتحديث الأسعار أو توفر الأصناف',
    home_comparison_before_4: 'صعوبة تتبع الطلبات والمخزون وتسرب الأرباح',
    home_comparison_before_5: 'أخطاء بشرية متكررة في استلام وتنفيذ الطلبات',
    home_comparison_after_1: 'منيو رقمي تفاعلي يتحدث تلقائياً وبشكل فوري',
    home_comparison_after_2: 'توفير يصل إلى 80% من تكاليف الطباعة والورق',
    home_comparison_after_3: 'تحديث فوري وشامل للأسعار بضغطة زر واحدة',
    home_comparison_after_4: 'تتبع لحظي ودقيق لكل منتج وحركة في المخزون',
    home_comparison_after_5: 'دقة متناهية 100% في استلام ومعالجة الطلبات',

    home_awards_title: 'جوائز وشهادات تقدير',
    home_awards_subtitle: 'نفخر بثقة عملائنا وتقدير رواد الصناعة لتقنياتنا',
    home_award_1_title: 'أفضل منصة رقمية لعام 2025',
    home_award_1_org: 'جائزة التميز التقني السعودي',
    home_award_2_title: 'تقييم 4.9/5 في منصات التقييم العالمية',
    home_award_2_org: 'من أكثر من 500 علامة تجارية شريكة',
    home_award_3_title: 'شريك تقني معتمد للفوترة الإلكترونية',
    home_award_3_org: 'هيئة الزكاة والضريبة والجمارك (ZATCA)',
    home_award_4_title: 'المنصة الأسرع نمواً في قطاع الضيافة',
    home_award_4_org: 'تقرير النمو الصناعي 2025',

    home_pricing_subtitle: 'استثمار ذكي لنموك',
    home_pricing_desc: 'خطط أسعار تنافسية تلائم طموحك',
    home_pricing_note: 'اختر الباقة التي تناسب حجم نشاطك الحالي، وانطلق نحو التوسع بسهولة.',
    home_pricing_compare_subtitle: 'مقارنة تفصيلية',
    home_pricing_compare_title: 'حلل مميزات وخصائص كل باقة',
    home_pricing_compare_desc: 'اختر الباقة المثالية بناءً على الاحتياجات التشغيلية لنشاطك',
    home_pricing_features_label: 'المميزات والخصائص',
    home_pricing_basic: 'الباقة الأساسية',
    home_pricing_growth: 'باقة النمو 🚀',
    home_pricing_enterprise: 'باقة الشركات الكبرى',
    home_pricing_popular: 'الباقة الأكثر طلباً واعتماداً',
    home_pricing_cta_start: 'ابدأ تجربتك المجانية',
    home_pricing_cta_contact: 'تواصل مع فريق المبيعات',
    home_pricing_tip: 'ملاحظة: جميع الباقات تشمل تحديثات مستمرة وإمكانية الإلغاء في أي وقت',
    home_pricing_tax_note: 'جميع الأسعار الموضحة لا تشمل ضريبة القيمة المضافة (15%)',

    home_preview_label: 'لوحة تحكم مركزية متطورة',
    home_preview_title: 'أدِر كل تفاصيل عملك بدقة فائقة',
    home_preview_desc: 'وداعاً لتشتت الأنظمة. تابع المبيعات اللحظية، راقب أداء الفروع، أدر المخزون، ووافق على طلبات التوصيل، كل ذلك من شاشة سحابية واحدة فائقة السرعة.',
    home_preview_list_1: 'تحديثات لحظية ومباشرة عبر تقنية WebSockets',
    home_preview_list_2: 'تقارير تحليلية ذكية تدعم اتخاذ قراراتك الاستراتيجية',
    home_preview_list_3: 'نظام صلاحيات متقدم لإدارة الموظفين والمدراء بأمان',
    home_preview_sales: 'إجمالي المبيعات اليومية الحالية',
    home_preview_trend: 'نسبة النمو المحققة',
    home_preview_new_order: 'تنبيه: تم استلام طلب جديد بنجاح',
    home_preview_order_item: 'وجبة عائلية فاخرة',
    home_preview_order_status: 'تم الاستلام - قيد التحضير',

    home_sectors_subtitle: 'تخصصنا في مجالك يمنحك الأفضلية',
    home_sectors_title: 'حلول هندسية مخصصة لكل نوع من الأعمال الغذائية',
    home_sectors_desc: 'نحن نؤمن بالتخصص؛ لذا صممنا مميزات خاصة تلبي الاحتياجات الفريدة للمخابز، المقاهي، والمطابخ السحابية بدقة.',
    home_sectors_cta: 'اكتشف الباقة المثالية لنوع نشاطك',
    home_sector_restaurants: 'المطاعم الراقية والفاخرة',
    home_sector_bakery: 'المخابز والحلويات التقليدية',
    home_sector_cafes: 'المقاهي ومحامص القهوة المختصة',
    home_sector_kitchens: 'المطابخ السحابية عالية التشغيل',

    home_cta_title: 'هل أنت مستعد لنقل مطعمك للمستوى التالي؟',
    home_cta_desc: 'انضم لرواد التحول الرقمي اليوم. ابدأ فترة تجربة مجانية لمدة 14 يوماً بكافة المميزات وبدون أي التزامات.',
    home_cta_btn_trial: 'ابدأ تجربتك المجانية الآن',
    home_cta_btn_sales: 'احجز استشارة تقنية مجانية',

    home_footer_desc: 'الشريك التقني الأول لقطاع الضيافة في المملكة. نقدم بنية تحتية سحابية متطورة تهدف لتحسين الكفاءة التشغيلية وزيادة أرباحك.',
    home_footer_links: 'روابط التنقل السريع',
    home_footer_support: 'المصادر والدعم الفني',
    home_footer_blog: 'مدونة التكنولوجيا والضيافة',
    home_footer_help: 'مركز المعرفة المتكامل',
    home_footer_api: 'توثيق المبرمجين (API)',
    home_footer_status: 'حالة البنية التحتية للنظام',
    home_footer_contact: 'تواصل مع فريق الخبراء',
    home_footer_privacy: 'ميثاق خصوصية البيانات والأمان',
    home_footer_terms: 'شروط الاستخدام والتشغيل',
    home_footer_copyright_fixed: 'جميع الحقوق محفوظة لمنصة DFOOD © 2026',

    auth_version: 'الإصدار 2.0 (احترافي)',
    auth_2faTitle: 'المصادقة الثنائية (MFA)',
    auth_2faDesc: 'يرجى إدخال رمز التحقق من تطبيق المصادقة الخاص بك',
    auth_verifyLogin: 'تحقق ومزامنة الدخول',

    // Auth & Identity Operations (Missing Keys)
    auth_loginTitle: 'بوابة دخول النظام',
    auth_loginSubtitle: 'منصة ديفود - الإدارة الذكية للضيافة الرقمية',
    auth_emailLabel: 'البريد الإلكتروني',
    auth_passwordLabel: 'كلمة المرور',
    auth_forgotPassword: 'نسيت كلمة المرور؟',
    auth_loginBtn: 'تسجيل الدخول الآن',
    auth_noAccount: 'ليس لديك حساب؟',
    auth_registerLink: 'فتح حساب منشأة جديدة',
    auth_backToHome: 'العودة للرئيسية',
    auth_otpTitle: 'التحقق من رقم الجوال',
    auth_otpDesc: 'أدخل الرمز المكون من 6 أرقام المرسل إلى {phone} عبر الواتساب',
    auth_verifyBtn: 'تحقق ومزامنة الدخول',
    auth_benefit1_title: 'قوائم تفاعلية ذكية',
    auth_benefit1_desc: 'تحديث فوري للأسعار وصور الأصناف بضغطة زر.',
    auth_benefit2_title: 'تجربة عميل سلسة',
    auth_benefit2_desc: 'لا حاجة لتحميل أي تطبيق، فقط امسح واطلب.',
    auth_benefit3_title: 'تقارير وتحليلات',
    auth_benefit3_desc: 'اتخذ قرارات مبنية على بيانات دقيقة ومباشرة.',


    // Register Page Specific
    create_new_account: 'إنشاء حساب جديد',
    start_digital_journey_desc: 'ابدأ رحلة التحول الرقمي لمطعمك اليوم.',
    account_officer_data: 'بيانات المسؤول عن الحساب',
    creating_account: 'جاري إنشاء الحساب...',
    create_and_start_trial: 'إنشاء الحساب وبدء الفترة التجريبية',
    verify_your_phone: 'تحقق من رقم جوالك',
    enter_otp_sent_to: 'أدخل رمز التحقق المرسل إلى',
    via_whatsapp: 'عبر الواتساب',
    verifying: 'جاري التحقق...',
    confirm_and_create_account: 'تأكيد وإنشاء الحساب',
    resend_otp_in: 'إعادة إرسال الرمز خلال',
    seconds: 'ثانية',
    resend_otp_now: 'إعادة إرسال الرمز الآن',
    change_phone_number: 'تغيير رقم الجوال',
    registration_success_title: 'تم إنشاء الحساب بنجاح!',
    registration_success_desc: 'أهلاً بك في عائلة DFOOD. يمكنك الآن البدء في إعداد مطعمك.',
    account_created_successfully: 'تم إنشاء الحساب بنجاح',
    account_pending_review_message: 'حسابك الآن قيد المراجعة الإدارية. سنقوم بتفعيله قريباً وتزويدك بكافة التفاصيل.',
    go_to_login: 'الذهاب لتسجيل الدخول',
    back_to_home: 'العودة للرئيسية',

    // New Registration UI Keys
    join_future: 'انضم إلى مستقبل',
    digital_hospitality: 'الضيافة الرقمية',
    platform_desc: 'منصة متكاملة تمنحك السيطرة الكاملة على مطعمك، من القائمة الرقمية التفاعلية إلى إدارة المخزون والمبيعات.',
    benefit1_title: 'قوائم تفاعلية ذكية',
    benefit1_desc: 'تحديث فوري للأسعار وصور الأصناف بضغطة زر.',
    benefit2_title: 'تجربة عميل سلسة',
    benefit2_desc: 'لا حاجة لتحميل أي تطبيق، فقط امسح واطلب.',
    benefit3_title: 'تقارير وتحليلات',
    benefit3_desc: 'اتخذ قرارات مبنية على بيانات دقيقة ومباشرة.',

    full_name_placeholder: 'مثل: محمد عبدالله',
    restaurant_name_placeholder: 'مثل: مطعم الذواق',
    address_placeholder: 'مثل: جدة، شارع التحلية',
    otp_sent_success: 'تم إرسال رمز التحقق عبر الواتس اب',
    enter_6_digit_otp: 'يرجى إدخال رمز المكون من 6 أرقام',
    creating_account_loading: 'جاري إنشاء الحساب...',

    // Validation
    val_emailRequired: 'البريد الإلكتروني (الهوية) مطلوب',
    val_emailInvalid: 'صيغة البريد الإلكتروني غير صحيحة',
    val_passwordRequired: 'مفتاح الدخول مطلوب للمصادقة',
    val_otpRequired: 'رمز التحقق إلزامي',
    val_nameRequired: 'الاسم القانوني مطلوب لإنشاء الملف الشخصي',
    val_passwordShort: 'يجب أن لا تقل كلمة المرور عن 8 خانات',
    val_passwordMismatch: 'فشل التحقق من كلمة المرور - المفاتيح غير متطابقة',
    val_businessNameRequired: 'اسم المنشأة مطلوب',
    val_phoneRequired: 'رقم الجوال مطلوب للتواصل',
    val_phoneShort: 'رقم الجوال قصير جداً',
    val_addressRequired: 'العنوان التشغيلي للمنشأة مطلوب',
    val_typeRequired: 'يرجى اختيار نوع النشاط',

    // Register extra validations
    name_required: 'الاسم الكامل مطلوب',
    email_required: 'البريد الإلكتروني مطلوب',
    invalid_email: 'بريد إلكتروني غير صحيح',
    password_required: 'كلمة المرور مطلوبة',
    password_min_length: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    passwords_not_match: 'كلمتا المرور غير متطابقتين',
    restaurant_name_required: 'اسم المنشأة مطلوب',
    phone_required: 'رقم الجوال مطلوب',
    phone_too_short: 'رقم الجوال قصير جداً',
    address_required: 'العنوان مطلوب',
    activity_required: 'نوع النشاط مطلوب',

    // New Keys for HomePage Refactor
    no_limit: 'غير محدود',
    apps: 'تطبيقات',
    custom: 'مخصص',
    basic: 'أساسي',
    advanced: 'متقدم',
    training: 'التدريب والإعداد',
    account_manager: 'مدير حساب مخصص',
    home_mockup_restaurant_name: 'برجر هاوس',
    home_mockup_category_all: 'الكل',
    home_mockup_category_burger: 'برجر',
    home_mockup_category_pizza: 'بيتزا',
    home_mockup_category_drinks: 'مشروبات',
    home_mockup_product_name: 'برجر دبل تشيز',
    home_mockup_product_desc: 'لحم واغيو، جبنة شيدر، صوص خاص',
    home_mockup_discount_title: 'خصم 20%',
    home_mockup_discount_desc: 'على جميع الوجبات العائلية',

    // Kiosk Management
    kioskManagement: 'إدارة وتنسيق الكشك الذاتي',
    kioskSettingsGeneral: 'الإعدادات الأساسية',
    kioskMenuControl: 'التحكم في ظهور القائمة',
    attractorInterface: 'هندسة شاشة الجذب',
    attractorTitleLabel: 'العنوان الرئيسي الجاذب',
    paymentMethodsAllowed: 'بروتوكولات الدفع المصرح بها',
    electronicPayment: 'التسوية الرقمية (مدى، فيزا، آبل باي)',
    cashOnDeliverySoon: 'التسوية النقدية (عند الاستلام) - مجدولة قريباً',
    attractorImagesScroll: 'التسلسل البصري السينمائي (روابط الصور)',
    saveAndBroadcast: 'اعتماد ونشر التغييرات',
    kioskPreviewLabel: 'محاكاة حية لجهاز الكشك',
    kioskMenuTitle: 'تنسيق قائمة الكشك المخصصة',
    kioskMenuDesc: 'تحديد الأقسام والمنتجات المتاحة للوصول عبر أجهزة الخدمة الذاتية.',
    kioskVisibility: 'الظهور في الكشك',
    kioskShow: 'مفعل التشغيل',
    kioskHide: 'محجوب / مخفي',
    kioskPreviewBtn: 'تشغيل المحاكاة',
    copyKioskLink: 'نسخ رابط الكشك (URI)',
    kioskGuideTitle: 'دليل التخطيط الاستراتيجي للكشك',

    // Floor Plan / Table Management
    floorPlanTitle: 'الذكاء المكاني وتصميم الصالة',
    floorPlanSubtitle: 'هندسة المخطط الفيزيائي لمنشأتك بدقة السحب والإفلات.',
    editSpatialLayout: 'تفعيل تعديل المخطط',
    saveSpatialLayout: 'حفظ وتثبيت التوزيع المكاني',
    addNewTable: 'إضافة وحدة مكانية جديدة (طاولة)',
    tableProperties: 'مواصفات الوحدة',
    tableNumberLabel: 'معرّف الطاولة (الرقم)',
    nodeCapacity: 'الطاقة الاستيعابية (ضيوف)',
    nodeShape: 'الشكل الهندسي',
    nodeRotation: 'التوجيه الزاوي',
    deleteNode: 'إلغاء تشغيل الوحدة (حذف)',
    identifyNode: 'حدد وحدة مكانية لتعديل سماتها أو بصمتها في المساحة.',
    spatialStats: 'رؤى التشغيل المكاني',
    nodeStatusAvailable: 'جاهز / متاح',
    nodeStatusOccupied: 'مشغول / إيراد نشط',

    // Add these missing keys
    whatsapp_verification: 'التحقق عبر الواتساب',
    otp_sent_message: 'تم إرسال رمز التحقق إلى رقم الجوال:',
    verify_and_continue: 'تحقق واستمرار',
    resend_code_in_seconds: 'إعادة إرسال الرمز خلال {seconds} ثانية',
    change_phone_label: 'تغيير رقم الجوال',
    create_account: 'إنشاء الحساب الآن',
    back_to_login: 'العودة لتسجيل الدخول',
    or: 'أو',
    otp_not_received_hint: 'لم يصلك الرمز؟ يمكنك استخدام رمز التفعيل اليدوي للمسؤولين.',
    // Register Page Missing Keys (Synced with RegisterPage.jsx)
    full_name: 'الاسم الكامل للمسؤول',
    password: 'كلمة المرور (مفتاح الدخول)',
    confirm_password: 'تأكيد كلمة المرور',
    establishment_data: 'بيانات المنشأة / المكان',
    restaurant_name: 'اسم المطعم / النشاط التجاري',
    phone_contact: 'رقم الجوال للتواصل',
    city_address: 'العنوان / المدينة',
    city_address_placeholder: 'مثل: الرياض، شارع التحلية',
    activity_type: 'نوع النشاط التشغيلي',
    restaurant: 'مطعم',
    cafe: 'مقهى / كوفي شوب',
    juice: 'محل عصائر',
    bakery: 'مخبز / حلويات',
    sweets: 'محل حلويات',
    cafeteria: 'بوفيه / كافتيريا',
    food_truck: 'عربة طعام (Food Truck)',

    // Dashboard Guide

    // Sidebar & Navigation Additional
    sidebar_accounting: 'النظام المحاسبي المتكامل',
    sidebar_inventory: 'إدارة المستودعات والمخزون',
    sidebar_purchases: 'عمليات المشتريات والتوريد',
    sidebar_staff: 'شؤون الموظفين والرواتب',
    sidebar_marketing: 'التسويق ونمو المبيعات',
    sidebar_settings: 'إعدادات المنشأة',

    // Daily Journal & Accounting
    allUsers: 'كل الموظفين',
    journalEntriesTotal: 'إحصائيات قيود اليومية',
    currentBalance: 'فرق الرصيد (الميزان)',
    allTypes: 'كل الأنواع',
    manual: 'يدوي',
    automated: 'آلي',
    reversal: 'عكسي',
    showing: 'عرض',
    entryDetails: 'تفاصيل القيد',
    newJournalEntry: 'قيد يومية جديد',
    manualJournalEntryDesc: 'تسجيل قيد محاسبي يدوي في دفتر اليومية العامة.',
    reversalReason: 'سبب العكس',
    minAmount: 'الحد الأدنى للمبلغ',
    maxAmount: 'الحد الأقصى للمبلغ',
    referenceType: 'نوع المرجع',
    postedBy: 'بواسطة',

    // Security & Preferences Tab Settings
    settings_dateTimeFormats: 'تنسيقات الوقت والتاريخ',
    dateFormat: 'صيغة التاريخ',
    timeFormat: 'صيغة الوقت',
    settings_passwordPolicies: 'سياسات كلمات المرور بقوة التشفير',
    passwordMinLength: 'الحد الأدنى لطول كلمة المرور',
    sessionTimeoutMinutes: 'مهلة انتهاء الجلسة بالدقائق',
    requireUppercase: 'طلب حروف كبيرة (A-Z)',
    requireUppercaseDesc: 'يجب احتواء كلمة المرور على حرف كبير واحد على الأقل.',
    requireLowercase: 'طلب حروف صغيرة (a-z)',
    requireLowercaseDesc: 'يجب احتواء كلمة المرور على حرف صغير واحد على الأقل.',
    requireNumbers: 'طلب أرقام (0-9)',
    requireNumbersDesc: 'يجب احتواء كلمة المرور على رقم واحد على الأقل.',
    requireSymbols: 'طلب رموز خاصة (#$%!)',
    requireSymbolsDesc: 'يجب احتواء كلمة المرور على رمز خاص واحد على الأقل.',
    mustChangePasswordNext: 'إجبار الموظفين على تغيير كلمة المرور في الدخول القادم',
    mustChangePasswordDesc: 'سيتم إجبار كافة الموظفين الذين تم إنشاؤهم حديثاً على تعيين كلمة مرور جديدة عند أول تسجيل دخول.',
    twoFactorAuth: 'التحقق بخطوتين (2FA)',

    // POS Open Price Modal Settings
    pos_openPriceTitle: 'تحديد سعر حر للمنتج',
    pos_productLabel: 'المنتج:',
    pos_invalidPriceError: 'الرجاء إدخال سعر صحيح أكبر من الصفر',
    pos_clearField: 'مسح الحقل',
    pos_hideNote: 'إخفاء الملاحظة',
    pos_addNote: 'إضافة ملاحظة',
    pos_notePlaceholder: 'أضف ملاحظة أو سبب تعديل السعر...',
    pos_confirmPrice: 'تأكيد السعر',

    // Missing Keys from English Dictionary
    reversed: 'عكسي / مرتجع',
    reversalFor: 'قيد عكسي لـ',
    reverseEntryHint: 'سيتم إنشاء قيد جديد بنفس القيم مع عكس الحسابات.',
    checks: 'الشيكات',
    netVatPayable: 'صافي ضريبة القيمة المضافة المستحقة (للهيئة)',
    netVatRefundable: 'صافي ضريبة القيمة المضافة المستردة (من الهيئة)',
    preparedBy: 'إعداد',
    approvedBy: 'اعتماد',
    restaurantSettings: 'إعدادات المطعم',
    journalVoucher: 'قيد اليومية',
    totalAssets: 'إجمالي الأصول',
    totalLiabilities: 'إجمالي الالتزامات',
    totalEquity: 'إجمالي حقوق الملكية',
    totalLiabilitiesAndEquity: 'إجمالي الالتزامات وحقوق الملكية',
    liabilitiesAndEquity: 'الالتزامات وحقوق الملكية',
    currencySymbol: 'ر.س',
    refreshData: 'تحديث البيانات',
    draft: 'مسودة',
    posted: 'مرحل',
    receipt: 'سند قبض',
    payment: 'سند صرف',
    parent: 'حساب رئيسي',
    noCostCenters: 'لا توجد مراكز تكلفة',
    transferDescription: 'وصف عملية التحويل',
    confirmTransfer: 'تأكيد التحويل',
    fillFields: 'يرجى تعبئة الحقول المطلوبة',
    introduction: 'مقدمة',
    growth: 'نمو',
    maturity: 'نضوج',
    decline: 'تراجع',
    daysOnMenu: 'أيام في القائمة',
    day: 'يوم',
    crossSellSubtitle: 'منتجات تطلب غالباً معاً',
    times: 'مرات',
    suggestedDiscount: 'الخصم المقترح',
    winter: 'شتاء',
    spring: 'ربيع',
    summer: 'صيف',
    autumn: 'خريف',
    currentSeason: 'الموسم الحالي',
    promoteThese: 'ترويج هذه الأصناف',
    introduceNew: 'أصناف جديدة مقترحة',
    discountOrRemove: 'تخفيض السعر أو الإزالة',
    margin: 'الهامش',
    postConfirm: 'هل أنت متأكد من ترحيل هذا السند؟ هذا الإجراء لا يمكن التراجع عنه.',
    postSuccess: 'تم الترحيل بنجاح',
    auth_registerTitle: 'تسجيل منشأة جديدة',
    auth_registerSubtitle: 'ابدأ التحول الرقمي لمنشأتك بخطوات بسيطة',
    auth_personalInfo: 'بيانات المدير المسؤول',
    auth_businessInfo: 'معلومات المنشأة والنشاط',
    auth_fullName: 'الاسم الكامل',
    auth_businessName: 'اسم المنشأة',
    auth_phone: 'رقم الجوال الأساسي',
    auth_city: 'المدينة / العنوان',
    auth_businessType: 'نوع النشاط',
    auth_registerBtn: 'إنشاء الحساب وبدء الفترة التجريبية',
    auth_confirmPassword: 'تأكيد كلمة المرور',
    auth_resendOtp: 'إمكانية إعادة إرسال رمز التحقق خلال {timer} ثانية',
    auth_resendOtpNow: 'إعادة إرسال رمز التحقق الآن',
    auth_changePhone: 'تغيير رقم الجوال',
    auth_successTitle: 'تم تسجيل طلبك بنجاح!',
    auth_successDesc: 'طلبك قيد المراجعة والتدقيق حالياً. سيتم إرسال تنبيه فور تفعيل الحساب.',
    auth_welcomeTitle: 'انضم إلى مستقبل الضيافة الرقمية',
    auth_welcomeTitle_br: 'انضم إلى مستقبل الضيافة الرقمية',
    auth_welcomeTitle_highlight: 'الضيافة الرقمية',
    auth_welcomeDesc: 'منصة متكاملة تمنحك السيطرة الكاملة على مطعمك، من المنيو الرقمي التفاعلي إلى إدارة المخزون والمبيعات.',
    auth_menuTheme: 'طابع القائمة المفضل',
    auth_menuTheme_hint: 'يمكنك بسهولة تغيير التصميم لاحقاً من لوحة التحكم.',
    numberFormatLabel: 'آلية الأرقام في النظام',
    numberFormatEnglish: 'الأرقام الإنجليزية (123...)',
    numberFormatArabic: 'الأرقام العربية (١٢٣...)',
    numberFormatPreview: 'معاينة الأرقام في التقارير والفواتير:',
    theme_classic: 'كلاسيكي',
    theme_luxury: 'فاخر',
    theme_premium: 'عصري حديث',
    roundingDifferenceAccount: 'حساب فروقات التقريب والورديات',
    payrollAndAssetsAccounts: 'حسابات الرواتب والأصول',
    salaryExpenseAccount: 'حساب مصروف الرواتب',
    salaryPayableAccount: 'حساب رواتب مستحقة الدفع',
    depreciationExpenseAccount: 'حساب مصروف الإهلاك',
    accumulatedDepreciationAccount: 'حساب مجمع الإهلاك',
};
